import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';
import authService from '../services/authService';
import Footer from '../components/ui/Footer';

const NewPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [error, setError] = useState("");
    const [formData, setFormData] = useState({
        newPassword: "",
        confirmPassword: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Extract the session_token from the URL query parameters
    const queryParams = new URLSearchParams(location.search);
    const session_token = queryParams.get('session_token'); // Get the session_token

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate if passwords match
        if (formData.newPassword !== formData.confirmPassword) {
            setError("Passwords do not match.");
            return;
        }

        console.log("Password Reset Data Submitted:", formData);
        
        // Logic to send new password to backend
        try {
            const { response, data } = await authService.resetPassword(session_token, formData.newPassword);

            if (response.ok) {
                // If the password was updated successfully
                console.log("Password successfully updated!");
                Swal.fire("Password successfully updated!", "", "success");
                navigate("/login"); // Redirect to the login page
            } else {
                // If there was an error (e.g., invalid session token)
                console.error("Error:", data.error);
                setError(data.error);
            }
        } catch (error) {
            // Handle network or other errors
            console.error("Failed to reset password:", error);
            setError("Failed to reset password. Please try again.");
        }
    };

    const handleHome = () => {
        navigate("/"); 
    };

    return (
        <div className="min-h-screen flex flex-col">
            <nav className="bg-[#003153] p-4 sticky z-20 top-0">
                <div className="container mx-auto flex justify-between items-center">
                    <div className="text-white text-2xl font-bold">DEEBug</div>
                    <div>
                        <button className="bg-[#E6ECF2] text-[#003153] px-3 py-1 rounded transition duration-200 font-bold hover:bg-[#E6F3FF]" onClick={handleHome}>Home</button>
                    </div>
                </div>
            </nav>
            
            <main className="flex-1 flex items-center justify-center px-4">
                <div className="w-full max-w-md">
                    <div className="bg-[#E6F3FF] border border-[#003153] rounded-md p-6 sm:p-8">
                        <h2 className="text-2xl font-bold text-[#003153] text-center mb-6">New Password</h2>
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div>
                                <label htmlFor="newPassword" className="block text-sm font-medium text-[#003153] mb-2">New Password:</label>
                                <input
                                    type="password"
                                    id="newPassword"
                                    name="newPassword"
                                    value={formData.newPassword}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#003153] focus:border-[#003153]"
                                    required
                                />
                            </div>
                            <div>
                                <label htmlFor="confirmPassword" className="block text-sm font-medium text-[#003153] mb-2">Confirm Password:</label>
                                <input
                                    type="password"
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#003153] focus:border-[#003153]"
                                    required
                                />
                            </div>
                            <button type="submit" className="w-full bg-[#003153] text-white py-2 px-4 rounded-md hover:bg-[#004471] transition duration-200 font-medium">
                                Update Password
                            </button>
                            {error && <p className="text-red-600 text-sm text-center mt-2">{error}</p>}
                        </form>
                        
                        <div className="mt-6 text-center">
                            <p className="text-gray-600">
                                Go back to{" "}
                                <button onClick={() => navigate("/login")} className="text-[#003153] font-medium hover:underline">
                                    Log In
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </main>
            
            <Footer />
        </div>
    );
};

export default NewPassword;
